import 'babel-polyfill'
import Vue from 'vue'
import App from './index.vue'
import router from './router'
import VueLazyload from 'vue-lazyload'
import { wxShare } from 'api/wx-share.js'
// import fastclick from 'fastclick'
import { Toast } from 'wc-messagebox'
import 'wc-messagebox/style.css'
import 'common/stylus/index.styl'
import 'common/fonts/iconfont.css'
import Config from './utils/config'
import { getScrollTop, getScrollHeight, getWindowHeight } from './utils/dom.js'
import store from './store'
import statusCodes from './config/error-handler'
// fastclick.attach(document.body)
Vue.use(VueLazyload, {
  error: require('common/image/error.png'),
  loading: require('common/image/default.png'),
  attempt: 1
})
Vue.use(Toast, {})
// Vue.use(Alert, {})
// Vue.use(Confirm, {})

let fisrtIn = true
/* eslint-disable */
router.beforeEach((to, from, next) => {
  // console.log('to', to)
  // console.log('from', from)
  // 路由发生变化修改页面title
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (fisrtIn && to.path !== '/index') {
    Config.inUrl = to.path
    Config.query = to.query
    next('/index')
  } else {
    next()
  }
  fisrtIn = false
})

router.afterEach((to, from) => {
  // 微信分享
  wxShare()
})

// 全局时间过滤器
Vue.filter('format', function (time) {
  let t = parseInt(time)
  let h = parseInt(t / 60)
  let m = parseInt(t % 60)
  return (h ? h + '小时' : '') + (m ? m + '分钟' : '')
})

let loadmorelist = []
// 加载更多指令
Vue.directive('loadmore', {
  bind: (el, binding) => {
    // console.log('执行了指令')
    loadmorelist.push(binding.value)
  },
  unbind: (el, binding) => {
    // console.log('unbind')
    loadmorelist.splice(loadmorelist.indexOf(binding.value), 1)
  }
})
let onscrollList = []
// 监听滚动
Vue.directive('onscroll', {
  bind: (el, binding) => {
    // console.log('执行了指令', onscrollList.length)
    onscrollList.push(binding.value)
  },
  unbind: (el, binding) => {
    // console.log('unbind', onscrollList.length)
    onscrollList.splice(onscrollList.indexOf(binding.value), 1)
  }
})
window.onscroll = function () {
  const scrollTop = getScrollTop()
  if (scrollTop + getWindowHeight() >= getScrollHeight() && scrollTop > 0) {
    // console.log('滚动到底部')
    // 执行回调函数
    //binding.value()
    loadmorelist.forEach((item) => {
      item()
    })
  }
  // 触发注册了监听滚动的指令
  onscrollList.forEach((item) => {
    item(scrollTop)
  })
}


/* eslint-disable no-new */
let app = new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
/**router.onReady(() => {
  app.$mount('#app')
})**/
// 监听请求状态码变化
store.watch(state => state.status, (status) => {
  statusCodes.forEach(item => {
    if (status.code === item.code) {
      router.push(item.path)
      return
    }
  })
})



// WEBPACK FOOTER //
// ./src/index.js